import React from "react";

export type TThemeVariant = "light" | "dark";

export interface IThemeContext {
  variant: TThemeVariant;
}

export default React.createContext<IThemeContext>({
  variant: "light",
});
